import script from "./cgw_zyml.vue?vue&type=script&setup=true&lang=js"
export * from "./cgw_zyml.vue?vue&type=script&setup=true&lang=js"

import "./cgw_zyml.vue?vue&type=style&index=0&id=2fd4a2d5&lang=less"

const __exports__ = script;

export default __exports__